import React from "react";

function FormAlert(props) {
  return (
    <div
      className={
        "text-center p-4 rounded" +
        (props.type === "error" ? " text-red-600 bg-red-50" : "") +
        (props.type === "success" ? " text-green-600 bg-green-50" : "") +
        (props.type === "info" ? " text-blue-600 bg-blue-50" : "")
      }
    >
      {typeof props.message === 'string' ? (
        <p>{props.message}</p>
      ) : (
        props.message
      )}
    </div>
  );
}

export default FormAlert;
